import logo from './logo.svg';
import './App.css';
import Nav2 from './components/Nav2.js';
import { BrowserRouter as Router ,Switch,Route} from 'react-router-dom';
import Home from './components/Home';
import Reservation from './components/Reservation';
import { Card } from 'react-bootstrap';
import Cart from './components/Cart';
import Forms from './components/Forms';
import {OrderProvider} from './Contexts/OrderProvider'
import {DetailProvider} from './Contexts/DetailProvider'
import Finalpage from './components/Finalpage';
function App() {
  return (
    <OrderProvider>
      <DetailProvider>
         <Router > 
  <div>
    <Nav2/>
    <Switch>
      <Route path="/" exact component={Home}/>
      <Route path="/Reservation" exact component={Reservation}/>
      <Route path="/Menu" exact component={Home}/>
      <Route path="/Cart" exact component={Cart}/>
      <Route path="/Form" exact component={Forms}/>    
      <Route path="/Finalpage" exact component={Finalpage}/>
          </Switch>
  </div>
  </Router>
     </DetailProvider>
    </OrderProvider>
   
  
  );
}

export default App;
